import { render, staticRenderFns } from "./MasterPhraseNew.vue?vue&type=template&id=70c1c691&scoped=true&lang=pug&"
import script from "./scripts/MasterPhraseNew.js?vue&type=script&lang=js&"
export * from "./scripts/MasterPhraseNew.js?vue&type=script&lang=js&"
import style0 from "./MasterPhraseNew.vue?vue&type=style&index=0&id=70c1c691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1c691",
  null
  
)

export default component.exports